import React, { useEffect, lazy, useState, } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ParentStyled from './style';
import {
  loadStyle,
  hasEnabledFeature,
  loadPageConfig,
  getNewObject,
  hasRestrictedRole
} from 'globalutils/fmUtils';
import { pageUrls, ROLES } from 'globalconfig/constants/keys';
import { sortColumnMapping } from './config';

let Styled = loadStyle(ParentStyled, 'pages/web/UnassignedInspections');
const layout = window?.$environment?.CURRENT_LAYOUT;

const config = loadPageConfig();
const Content = lazy(() => import(`@/${config.unassignedInspections[1].name}`));
const Tab = lazy(() => import(`globalcomponents/UI/Tab/${layout}`));

const Inspections = (parentProps) => {
  const {
    fetchInspections,
    getFilters,
    fetchDriverUserListing,
    getDocumentToken,
    history,
    i18n,
    theme
  } = parentProps;
  const commonParentProps = { history, i18n, Styled, theme };
  const basicRequest = {
    displayLength: '15',
    displayStart: '1'
  };
  const [pagination, setPagination] = useState(false);

  const [request, setRequest] = useState({
    ...basicRequest
  });

  const changeRequest = (fields) => {
    if (fields?.sortCol) {
      const type = fields.sortCol;
      fields.sortCol = sortColumnMapping[type]
        ? sortColumnMapping[type]
        : fields.sortCol;
    }
    setRequest({ ...basicRequest, ...fields });
  };

  useEffect(() => {
    fetchInspections({
      apiId: 'fetchPendingMechanicInspections',
      data: { request, state: 'UN_ASSIGNED' }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request]);

  useEffect(() => {
    fetchDriverUserListing({
      listApiId: 'fetchDriverUser'
    });
    getFilters({ apiId: 'getFilters' });
    getDocumentToken({ apiId: 'getDocToken' });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isCustomDviRequired =
    hasEnabledFeature('customDvirEnabled') &&
    !hasRestrictedRole([ROLES.SERVICE_MANAGER]);

  const isAdvancedDviRequired =
    hasEnabledFeature('advancedDvirEnabled') &&
    !hasRestrictedRole([ROLES.SERVICE_MANAGER]);

  return (
    <RenderComponentTab
      {...config.unassignedInspections[1]}
      parentProps={{
        ...parentProps,
        isAdvancedDviRequired,
        isCustomDviRequired,
        changeRequest,
        request,
        pagination,
        setPagination
      }}
      commonParentProps={commonParentProps}
      history={history}
      i18n={i18n}
      pagination={pagination}
      setPagination={setPagination}
    />
  );
};

const RenderComponentTab = ({
  name,
  props,
  commonProps,
  title,
  parentProps,
  commonParentProps,
  history,
  i18n,
  verticalTab,
  selectedIndex,
  setSelectedIndexfn,
  pagination,
  setPagination,
  ...rest
}) => {
  const handleChange = (event, newValue) => {
    history.push(tabValues[newValue].url);
  };

  let newProps = props?.length ? getNewObject(parentProps, props) : {};
  newProps = {
    ...newProps,
    ...(commonProps?.length
      ? getNewObject(commonParentProps, commonProps)
      : {}),
    ...rest
  };

  useEffect(() => {
    if (document.getElementById('list1')) {
      const isSelected = document
        .getElementById('list1')
        ?.className.includes('Mui-selected');
      document.getElementById('list1').className = !isSelected
        ? document.getElementById('list1').className + ' Mui-selected'
        : document.getElementById('list1').className;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document.getElementById('list1')]);

  const renderContent = () => (
    <Content
      {...newProps}
      selectedIndex={selectedIndex}
      pagination={pagination}
      setPagination={setPagination}
    />
  );

  const tabValues = [
    {
      name: 'Unassigned',
      url: pageUrls.unassignedInspections,
      value: renderContent
    },
    {
      name: 'Pending Mechanic',
      url: pageUrls.pendingMechanicInspections,
      value: renderContent
    },
    {
      name: 'Pending Driver',
      url: pageUrls.pendingDriverInspections,
      value: renderContent
    },
    {
      name: 'Completed',
      url: pageUrls.completedInspections,
      value: renderContent
    },
    {
      name: 'No Defect',
      url: pageUrls.noDefectInspections,
      value: renderContent
    }
  ];

  if (hasRestrictedRole([ROLES.SERVICE_MANAGER])) {
    tabValues.pop();
  }

  return (
    <Styled.Content>
      <Tab
        data={tabValues}
        className="logwrapper"
        currentTab={0}
        onChange={handleChange}
        vertical={true}
      />
    </Styled.Content>
  );
};

const mapState = (state) => {
  return {
    apiStatus: state.asyncRequests,
    inspections: state.pendingMechanicInspections,
    list: state.inspections,
    filters: state.filters,
    logBook: state.logBook
  };
};

const mapDispatch = (dispatch) => {
  return {
    fetchInspections: (data) =>
      dispatch.pendingMechanicInspections.fetchData(data),
    bulkDownloadReport: (data) => dispatch.logBook.downloadData(data),
    fetchDriverUserListing: (data) => dispatch.inspections.fetchData(data),
    getFilters: (data) => dispatch.filters.fetchData(data),
    getDocumentToken: (data) => dispatch.logBook.documentToken(data),
    clearApiStatus: () => dispatch.asyncRequests.clearApiStatus(),
    viewReport: (data) => dispatch.viewReport.viewReportDocument(data)
  };
};

export default connect(mapState, mapDispatch)(Inspections);

Inspections.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  fetchInspections: PropTypes.func.isRequired
};
